module.exports = __webpack_public_path__ + "static/media/file-pdf.cdc4bec3.svg";